import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpListJobCardComponent } from './components/sp-list-job-card/mul-sp-list-job-card.component';
import { IdentityModule } from '@flexus/identity';
import { MsalModule } from '@azure/msal-angular';
import { GetInvoicesService } from './services/get-invoices.service';
import { LoadSpManifestService } from '../../sp_globals/services/load-sp-manifest.service';
import { mul_sp } from './mul-sp.manifest';
import { SpGlobalModule } from '../../sp_globals/sp-global.module';
import { CreditNoteModule } from '@flexus/credit-note';
import { environment } from '../../../environments/environment';
import { PublicClientApplication } from '@azure/msal-browser';


export function loadConfig(manifest: LoadSpManifestService) {
	return function () {
		return manifest.load(mul_sp);
	};
}
@NgModule({
	imports: [
		CommonModule,
		CreditNoteModule,
		...environment.appShellFeatures,
		SpGlobalModule,
		environment['azure']
			? MsalModule.forRoot(
					new PublicClientApplication({
						auth: {
							clientId: environment['azure']['clientId'],
							postLogoutRedirectUri: `${environment.base_url}auth/login`
						}
					}),
					null,
					null
			  )
			: CommonModule,
		IdentityModule.forRoot({
			after_login_url: '/workflow',
			after_logout_url: '/auth/login',
			send_reset_link_endpoint: `${environment.api_url}v1/forgot_password/check-email`,
			login_endpoint: `${environment.api_url}v2/auth/login/`,
			no_auth_urls: ['/cons']
		})
	],
	declarations: [SpListJobCardComponent],
	exports: [...environment.appShellFeatures, SpListJobCardComponent],
	providers: [
		{
			provide: APP_INITIALIZER,
			useFactory: loadConfig,
			deps: [LoadSpManifestService, GetInvoicesService],
			multi: true
		}
	]
})
export class MulSpManifestModule {}
